import React from "react";
import { Form, Input, Switch, message } from "antd";
import { AddStageFormContainer, AddDivider } from "./styles";
import DefaultButton from "../../../../../../../shared/util/DefaultButton";
import StageProvider from "../../../../../../../shared/provider/StageProvider";

function AddStageForm({
  setOpen,
  isLoading = false,
  setLoading,
  setSuccessMessage,
  requireStageList,
}: {
  setOpen: React.Dispatch<boolean>;
  isLoading?: boolean;
  setLoading: React.Dispatch<boolean>;
  setSuccessMessage: React.Dispatch<string>;
  requireStageList: () => Promise<void>;
}) {
  const [form] = Form.useForm();
  const stageProvider = new StageProvider();

  async function createStage(values: any) {
    setLoading(true);

    try {
      const { stageName, stageDescription, stageOrder, isCompleted } = values;
      if (!stageName || !stageDescription || !stageOrder) {
        message.error("Preencha todos os campos");
        return;
      }

      const orderValue = Math.min(Number(stageOrder), 50);

      const response = await stageProvider.createOrUpdate({
        title: stageName,
        description: stageDescription,
        order: orderValue,
        isCompleted,
      });
      if (!response) throw new Error("Erro ao criar fase da idéia");
      setSuccessMessage("Fase da ideia salva com sucesso!");
      setTimeout(() => requireStageList(), 550);
    } catch (error) {
      message.error("Erro ao criar fase da idéia");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AddStageFormContainer>
      <Form form={form} layout="vertical" onFinish={createStage} requiredMark={false}>
        <Form.Item
          label="Nome da fase*"
          name="stageName"
          rules={[{ required: true, message: "Informe o nome da fase" }]}
        >
          <Input.TextArea
            showCount
            maxLength={100}
            autoSize={{ minRows: 1, maxRows: 3 }}
            disabled={isLoading}
          />
        </Form.Item>

        <AddDivider />

        <Form.Item
          label="Adicione uma descrição"
          name="stageDescription"
          rules={[{ required: true, message: "Descreva a fase" }]}
        >
          <Input.TextArea
            showCount
            maxLength={400}
            autoSize={{ minRows: 3, maxRows: 6 }}
            disabled={isLoading}
          />
        </Form.Item>

        <Form.Item>
          <Form.Item
            label="Ordem"
            name="stageOrder"
            rules={[{ required: true, message: "Informe a ordem" }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input
              type="number"
              min={0}
              max={50}
              disabled={isLoading}
            />
          </Form.Item>

          <Form.Item
            label="Fase final"
            name="isCompleted"
            valuePropName="checked"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginLeft: '16px' }}
          >
            <Switch checkedChildren="Ativo" unCheckedChildren="Inativo" disabled={isLoading} />
          </Form.Item>
        </Form.Item>

        <footer>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              onClick: () => setOpen(false),
            }}
          >
            Voltar
          </DefaultButton>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            params={{
              type: "button",
							onClick: () => form.submit(),
            }}
          >
            Cadastrar
          </DefaultButton>
        </footer>
      </Form>
    </AddStageFormContainer>
  );
}

export default AddStageForm;
